import { Area } from '@app/domain/Area'
import { Booking } from '@app/domain/Booking'
import { BookingReason } from '@app/domain/BookingReason'
import { CancellationReason } from '@app/domain/CancellationReason'
import { Contact } from '@app/domain/Contact'
import { Customer } from '../domain/Customer'
import { DTOAdapter } from '@services/DTOAdapter'
import { DiaryNote } from '@app/domain/DiaryNote'
import {
    EmailMarketingConfiguration,
} from '@app/domain/integration/email-marketing/EmailMarketingConfiguration'
import { Event } from '@app/domain/VenueEvent'
import { Injectable } from '@angular/core'
import { Question } from '@app/domain/Question'
import { Schedule } from '@app/domain/Schedule'
import { ScheduleRule } from '@app/domain/ScheduleRule'
import { Service } from '@app/domain/Service'
import { TableCombination } from '@app/domain/TableCombination'
import { Venue } from '@app/domain/Venue'
import { VenueClosure } from '../domain/VenueClosure'
import { Voucher } from '@app/domain/Voucher'
import { VenueSchedule } from '@app/domain/VenueSchedule'
import { BaseUser } from '@app/domain/BaseUser'
import { AccountUser } from '@app/domain/AccountUser'
import { Consumable, Menu } from '@app/domain/Consumable'
import { GiftedVoucher } from '@app/domain/GiftedVoucher'
import { POSConfiguration } from '@app/domain/pos/POSConfiguration'
import { POSTableMappingItem } from '@app/domain/pos/POSTableMappingItem'
import { Business } from '@app/domain/Business'

@Injectable({
    providedIn: 'root',
})
export class ModelCloningService {

    constructor(
        private dtoAdapter: DTOAdapter
    ) {
    }

    cloneArea(area: Area): Area {
        const dto = this.dtoAdapter.adaptArea(area)
        return this.dtoAdapter.adaptAreaDto(dto)
    }

    cloneBusiness(business: Business): Business {
        const dto = this.dtoAdapter.adaptBusiness(business)
        return this.dtoAdapter.adaptBusinessDto(dto)
    }

    cloneVenue(venue: Venue): Venue {
        const dto = this.dtoAdapter.adaptVenue(venue)
        return this.dtoAdapter.adaptVenueDto(dto)
    }

    cloneQuestion(question: Question): Question {
        const dto = this.dtoAdapter.adaptQuestion(question)
        return this.dtoAdapter.adaptQuestionDto(dto)
    }

    cloneSchedule(schedule: Schedule): Schedule {
        const dto = this.dtoAdapter.adaptSchedule(schedule)
        return this.dtoAdapter.adaptScheduleDto(dto)
    }

    cloneService(service: Service): Service {
        const dto = this.dtoAdapter.adaptService(service)
        return this.dtoAdapter.adaptServiceDto(dto)
    }

    cloneScheduleRule(rule: ScheduleRule): ScheduleRule {
        const dto = this.dtoAdapter.adaptScheduleRule(rule)
        return this.dtoAdapter.adaptScheduleRuleDto(dto)
    }

    cloneReason(reason: BookingReason): BookingReason {
        const dto = this.dtoAdapter.adaptBookingReason(reason)
        return this.dtoAdapter.adaptBookingReasonDto(dto)
    }

    cloneBooking(booking: Booking): Booking {
        const dto = this.dtoAdapter.adaptBooking(booking)
        return this.dtoAdapter.adaptBookingDto(dto)
    }

    cloneContact(contact: Contact): Contact {
        const dto = this.dtoAdapter.adaptContact(contact)
        return this.dtoAdapter.adaptContactDto(dto)
    }

    cloneCustomer(customer: Customer): Customer {
        const dto = this.dtoAdapter.adaptCustomer(customer)
        return this.dtoAdapter.adaptCustomerDto(dto)
    }

    cloneUser(user: BaseUser | AccountUser): BaseUser | AccountUser {
        const dto = this.dtoAdapter.adaptUser(user)
        return this.dtoAdapter.adaptUserDto(dto)
    }

    cloneEvent(event: Event): Event {
        const dto = this.dtoAdapter.adaptEvent(event)
        return this.dtoAdapter.adaptEventDto(dto)
    }

    cloneEmailMarketingConfiguration(integration: EmailMarketingConfiguration):
        EmailMarketingConfiguration {
        const dto = this.dtoAdapter.adaptEmailMarketingConfiguration(integration)
        return this.dtoAdapter.adaptEmailMarketingConfigurationDto(dto)
    }

    clonePOSConfiguration(integration: POSConfiguration): POSConfiguration {
        const dto = this.dtoAdapter.adaptPOSConfiguration(integration)
        return this.dtoAdapter.adaptPOSConfigurationDto(dto)
    }

    clonePOSTableMappingItem(item: POSTableMappingItem): POSTableMappingItem {
        const dto = this.dtoAdapter.adaptPOSTableMapping(item)
        return this.dtoAdapter.adaptPOSTableMappingDto(dto)
    }

    cloneTableCombination(tableCombination: TableCombination): TableCombination {
        const dto = this.dtoAdapter.adaptTableCombination(tableCombination)
        return this.dtoAdapter.adaptTableCombinationDto(dto)
    }

    cloneDiaryNote(diaryNote: DiaryNote): DiaryNote {
        const dto = this.dtoAdapter.adaptDiaryNote(diaryNote)
        return this.dtoAdapter.adaptDiaryNoteDto(dto)
    }

    cloneVenueSchedule(venueSchedule: VenueSchedule): VenueSchedule {
        const dto = this.dtoAdapter.adaptVenueSchedule(venueSchedule)
        return this.dtoAdapter.adaptVenueScheduleDto(dto)
    }

    cloneVenueClosure(closure: VenueClosure): VenueClosure {
        const dto = this.dtoAdapter.adaptVenueClosure(closure)
        return this.dtoAdapter.adaptVenueClosureDto(dto)
    }

    cloneConsumable(consumable: Consumable): Consumable {
        const dto = this.dtoAdapter.adaptConsumable(consumable)
        return this.dtoAdapter.adaptConsumableDto(dto)
    }

    cloneMenu(menu: Menu): Menu {
        const dto = this.dtoAdapter.adaptMenu(menu)
        return this.dtoAdapter.adaptMenuDto(dto)
    }

    cloneVoucher(voucher: Voucher): Voucher {
        const dto = this.dtoAdapter.adaptVoucher(voucher)
        return this.dtoAdapter.adaptVoucherDto(dto)
    }

    cloneGiftedVoucher(giftedVoucher: GiftedVoucher): GiftedVoucher {
        const dto = this.dtoAdapter.adaptGiftedVoucher(giftedVoucher)
        return this.dtoAdapter.adaptGiftedVoucherDto(dto)
    }

    cloneBookingReason(reason: BookingReason): BookingReason {
        const dto = this.dtoAdapter.adaptBookingReason(reason)
        return this.dtoAdapter.adaptBookingReasonDto(dto)
    }

    cloneCancellationReason(cancellationReason: CancellationReason): CancellationReason {
        const dto = this.dtoAdapter.adaptCancellationReason(cancellationReason)
        return this.dtoAdapter.adaptCancellationReasonDto(dto)
    }
}
